import { Box } from '@mui/material';
import { getStreamBalance, getStreamPackageSize, getStreamStatus, hasActiveStreamAccess } from 'src/utils/leadStreams';
import type { Stream } from 'src/services/LeadStreamsService/agent';

const planNames: Record<number, string> = { 50: 'Старт', 100: 'Про', 200: 'Бизнес' };

export default function StreamPlanBadge({ stream, packageSize }: { stream: Stream; packageSize?: number | null }) {
    const status = getStreamStatus(stream).key;
    const size = packageSize === undefined ? stream.fixed_package_size || getStreamPackageSize(stream) : packageSize;
    const name = size ? planNames[size] : undefined;
    if (!name || getStreamBalance(stream) <= 0 || hasActiveStreamAccess(stream) || !['active', 'paused'].includes(status)) return null;

    const business = size === 200;
    return (
        <Box component="span" sx={{
            display: 'inline-flex', alignItems: 'center', flexShrink: 0, px: 0.9, py: 0.3,
            borderRadius: '6px', border: '1px solid',
            borderColor: business ? '#20242C' : size === 100 ? '#A9C4FF' : '#E9DFD2',
            bgcolor: business ? '#20242C' : size === 100 ? '#EAF1FF' : '#FFF9F1',
            color: business ? '#F8FAFD' : size === 100 ? 'var(--lm-accent)' : '#172338',
            fontFamily: '"Inter", system-ui', fontSize: 11, fontWeight: 900, lineHeight: 1.2,
        }}>
            {name}
        </Box>
    );
}
